// Ordeneli brand mark — neural-circuit ring.
// Uses the PNG asset in /public so it scales with zero JS.
export default function OrdeneliMark({ size = 32, className = "" }) {
  return (
  <img
    src={`${process.env.PUBLIC_URL}/logo-mark.png`}
    alt=""
    width={size}
    height={size}
    aria-hidden="true"
    draggable={false}
    className={`shrink-0 select-none ${className}`}
    data-testid="ordeneli-mark"
    style={{ objectFit: "contain" }}
  />
  );
}
